import { motion } from "framer-motion";

export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="50" cy="50" r="46" stroke="#C5A059" strokeWidth="2.5" />
    <path d="M50 20L78 70H22L50 20Z" stroke="#8C6D27" strokeWidth="1.5" fill="none" />
    <path d="M35 52L50 26L65 52H35Z" fill="url(#logoGoldGrad)" />
    <rect x="30" y="60" width="40" height="12" rx="1" fill="#C5A059" stroke="#8C6D27" strokeWidth="1" />
    <defs>
      <linearGradient id="logoGoldGrad" x1="35" y1="26" x2="65" y2="52" gradientUnits="userSpaceOnUse">
        <stop stopColor="#DFBA6A" />
        <stop offset="1" stopColor="#8C6D27" />
      </linearGradient>
    </defs>
  </svg>
);

const Logo = ({ dark = false }) => (
  <motion.span
    className="inline-flex items-center gap-3"
    whileHover={{ scale: 1.02 }}
    transition={{ duration: 0.3 }}
  >
    <LogoMark />
    <span className={`flex flex-col leading-none ${dark ? "text-[#FAF8F5]" : "text-[#1A1816]"}`}>
      <span className="font-serif text-xl font-semibold tracking-[0.18em]">PACIFIC GOLD</span>
      <span className="font-sans text-[9px] font-medium tracking-[0.32em] text-[#8C6D27] uppercase mt-1">
        Wholesale Bullion · Liberia
      </span>
    </span>
  </motion.span>
);

export default Logo;
